module.exports = __webpack_public_path__ + "static/img/11.747acca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/11.png
// module id = Fw4J
// module chunks = 0